const tryRequire = require('try-require')
const webpack = require('webpack')

module.exports = function (state, opts, config) {
    const CompressionPlugin = tryRequire('compression-webpack-plugin')
    if (!CompressionPlugin) {
        return {} // waiting for an installation
    }

    config.plugins.push(new webpack.LoaderOptionsPlugin({
        minimize: true
    }))
    // config.plugins.push(new webpack.optimize.CommonsChunkPlugin({
    //   name: 'polifills',
    //   filename: 'babel-polyfills',
    //   // chunks: []
    // }))
    // config.plugins.push(new webpack.optimize.DedupePlugin())
    config.plugins.push(new webpack.optimize.AggressiveMergingPlugin())
    config.plugins.push(new webpack.optimize.UglifyJsPlugin({
    minimize: true,
    test: /\.(js|css)($|\?)/i,
    include: 'dist',
    ecma: 8,
    // include: path.resolve(PROJECT_PATH, 'dist')
    }))
    config.plugins.push(new CompressionPlugin({
    asset: "[path].gz[query]",
    algorithm: "gzip",
    test: /\.(js|css|html|htm)$/,
    threshold: 10240,
    minRatio: 0.8
    }))
    // config.plugins.push(new webpack.optimize.minimize())
    // config.plugins.push(new webpack.optimize.UglifyJsPlugin({
    //   minimize: true,
    //   test: /\.(js|css)($|\?)/i,
    //   include: 'dist',
    //   ecma: 8,
    //   // include: path.resolve(PROJECT_PATH, 'dist')
    // }))
}



// WEBPACK FOOTER //
// ./src/technologies/optimizations.js